import { request } from "../request";

export const getPopulationCount = (id, req) => {
  return request.post(`survey/count/total/${id}`, req);
};
export const getMalePopulationCount = (id, req) => {
  return request.post(`survey/count/male/${id}`, req);
};
export const getFemalePopulationCount = (id, req) => {
  return request.post(`survey/count/female/${id}`, req);
};
export const getTransgenderCount = (id, req) => {
  return request.post(`survey/count/transgender/${id}`, req);
};

export const addTodo = (data) => {
  return request.post("todo/create", data);
};
export const getUserTodo = (id) => {
  return request.get(`todo/user/read/${id}`);
};
export const delteTodoById = (id) => {
  return request.delete(`todo/${id}`);
};
export const updateTodoById = (id, data) => {
  return request.put(`todo//update/${id}`, data);
};
export const editUser = (id, data) => {
  return request.put(`user/update/${id}`, data);
};
export const uploadProfile = (userId, formBody) => {
  return request.post(`user/upload/${userId}`, formBody);
};
export const getUserById = (id) => {
  return request.get(`user/read/${id}`);
};

export const finalNotifiaction = () => {
  return request.get(`finalNotification/child`);
};

export const finalNotifiactionPreg = () => {
  return request.get(`finalNotification/preg`);
};
